var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerminalHeaderSelectorArrowDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "url(#paint0_linear_278_4793)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5497 10L8.4495 10C8.36749 10.0002 8.2871 10.017 8.21699 10.0485C8.14688 10.0801 8.08969 10.1253 8.0516 10.1792C8.0135 10.2331 7.99594 10.2936 8.00079 10.3544C8.00564 10.4151 8.03273 10.4738 8.07914 10.5239L12.1293 14.865C12.2971 15.045 12.7012 15.045 12.8695 14.865L16.9196 10.5239C16.9665 10.4739 16.994 10.4152 16.9991 10.3544C17.0042 10.2935 16.9868 10.2328 16.9487 10.1788C16.9105 10.1248 16.8532 10.0796 16.7829 10.048C16.7125 10.0165 16.6319 9.99991 16.5497 10Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_278_4793",
    x1: 12.5,
    y1: 0,
    x2: 12.5,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0066FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52C1F3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminalHeaderSelectorArrowDownIcon);
export default __webpack_public_path__ + "static/media/terminalHeaderSelectorArrowDownIcon.dfb47f7cb93734514f5e52079b387a99.svg";
export { ForwardRef as ReactComponent };